export type HireEmployeeRequestCreatePayload = {
  /** Id (int32) */
  id: number
  /** UserId (int32) */
  userId: number
  /** JobId (int32) */
  jobId: number
  /** Candidate name — English (API: EmpFirstNameEn, …) */
  empFirstNameEn: string
  empFatherNameEn: string
  empGrandNameEn: string
  empFamilyNameEn: string
  /** Candidate name — Arabic (API: EmpFirstNameAr, …) */
  empFirstNameAr: string
  empFatherNameAr: string
  empGrandNameAr: string
  empFamilyNameAr: string
  /** Position (string) */
  position: string
  /** SalaryRangeFrom (double) */
  salaryRangeFrom: number
  /** SalaryRangeTo (double) */
  salaryRangeTo: number
  /** TrainingCourses (string) */
  trainingCourses: string
  /** YearsOfExperience (int32) */
  yearsOfExperience: number
  /** Details (string) */
  details: string
  /** OtherRequiredQualification (string) */
  otherRequiredQualification: string
  /** EducationalQualification (string) */
  educationalQualification: string
  /** HireEmpImg (binary) */
  hireEmpImg: File | null
  /** BranchId (int32) */
  branchId: number
}

export const newHireEmployeeRequest = (): HireEmployeeRequestCreatePayload => ({
  id: 0,
  userId: 0,
  jobId: 0,
  empFirstNameEn: '',
  empFatherNameEn: '',
  empGrandNameEn: '',
  empFamilyNameEn: '',
  empFirstNameAr: '',
  empFatherNameAr: '',
  empGrandNameAr: '',
  empFamilyNameAr: '',
  position: '',
  salaryRangeFrom: 0,
  salaryRangeTo: 0,
  trainingCourses: '',
  yearsOfExperience: 0,
  details: '',
  otherRequiredQualification: '',
  educationalQualification: '',
  hireEmpImg: null,
  branchId: 0,
})

export type HireEmployeeRequestListItem = {
  id: number
  empId: number
  departmentId: number
  jobId: number
  position: string
  salaryRangeFrom: number
  salaryRangeTo: number
  trainingCourses?: string | null
  yearsOfExperience: number
  details?: string | null
  otherRequiredQualification?: string | null
  educationalQualification?: string | null
  attachmentUrl?: string | null
  status: number
  approvalDate?: string | null
  createdDate?: string | null
  createdBy?: number | null
  updatedById?: number | null
  updatedDate?: string | null
  isEditable?: number | boolean | null
  branchId?: number | null
  isEmployeeCreated?: boolean | null
}

export type HireEmployeeRequestListResponse = {
  totalRecords: number
  pageNumber: number
  pageSize: number
  data: HireEmployeeRequestListItem[]
}

/** Row from GET GetApprovalUsers?reqId= */
export type HireEmployeeApprovalUser = {
  id: number
  userName: string
  empId: number
  branchId: number
  actionDate: string | null
  action: string
  approvalNote: string | null
  departmentName: string
}

export type HireEmployeeRequestByIdResponse = {
  id: number
  empId: number
  departmentId: number
  jobId: number
  empFirstNameEn?: string | null
  empFatherNameEn?: string | null
  empGrandNameEn?: string | null
  empFamilyNameEn?: string | null
  empFirstNameAr?: string | null
  empFatherNameAr?: string | null
  empGrandNameAr?: string | null
  empFamilyNameAr?: string | null
  position: string
  salaryRangeFrom: number
  salaryRangeTo: number
  trainingCourses?: string | null
  yearsOfExperience: number
  details?: string | null
  otherRequiredQualification?: string | null
  educationalQualification?: string | null
  attachmentUrl?: string | null
  status?: number | null
  approvalDate?: string | null
  createdDate?: string | null
  createdBy?: number | null
  updatedById?: number | null
  updatedDate?: string | null
  isEditable?: number | boolean | null
  branchId?: number | null
  isEmployeeCreated?: boolean | null
}

